import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../../utilities/CustomDatePicker";
import FormPageHeader from "../../../utilities/FormPageHeader";
import PaidBy from "./PaidBy";
import "../../expense-claim/expenseClaim.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

const currentDate = new Date();

const ActionRenderer = (props) => {
  return (
    <div className="flex item-center">
      <Button color="warning" variant="contained" sx={{ mr: 1 }}>
        Pay
      </Button>
      <Button color="warning" variant="contained">
        {" "}
        View
      </Button>
    </div>
  );
};

export default function LoanRequest(props) {
  const navigate = useNavigate();
  const classes = useStyles(props);
  const { revision } = props;

  const [loanType, setLoanType] = useState([
    { label: "Salary Advance", value: "Salary Advance" },
    { label: "Housing Loan", value: "Housing Loan" },
    { label: "Car Loan", value: "Car Loan" },
    { label: "Personal Loan", value: "Personal Loan" },
    { label: "Other Loans", value: "Other Loans" },
  ]);

  const [rowOpen, setRowOpen] = useState(false);

  const installmentOption = [
    { label: "Monthly", value: "Monthly" },
    { label: "Quartely", value: "Quartely" },
    { label: "Semi Annually", value: "Semi Annually" },
  ];

  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);

  const gridRef = useRef();

  const [totalClaimed, setTotalClaimed] = useState();
  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const [tabValue, setTabValue] = useState("nolte");
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Loan Entry",
      children: [
        { field: "date", headerName: "Date" },
        { field: "amount", headerName: "Amount" },
        { field: "balance", headerName: "Balance" },
        { field: "status", headerName: "Status" },
        { field: "remarks", headerName: "Remarks" },
      ],
    },
  ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to cancel payment",
        message: "Are you sure to cancel payment ?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {},
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const handleRowDialogOpen = () => {
    setRowOpen(!rowOpen);
  };

  return (
    <>
      <FormPageHeader
        componentName="Salaries"
        pageName={revision ? "Loan Revision" : "Loan Request"}
        currentPage={revision ? "Loan Revision" : "Loan Request"}
      />

      <Dialog open={rowOpen} fullWidth maxWidth="sm" component="form">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              PAID BY NFZE
            </Typography>
            <IconButton onClick={handleRowDialogOpen}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
          <PaidBy />
        </DialogContent>
      </Dialog>

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="items-baseline">
          <Grid xs={4} item>
            <Stack className="my-8">
              <label>Employee Name</label>
              <TextField
                className="mb-4 w-[180px]"
                type="text"
                required
                variant="outlined"
                fullWidth
              />
            </Stack>
            <Stack className="my-8">
              <label>Loan Amount</label>
              <TextField
                className="mb-4 w-[180px]"
                type="text"
                required
                variant="outlined"
                fullWidth
              />
            </Stack>
            <Stack className="my-8">
              <label>Installment</label>

              <Select
                className="w-[180px]"
                name="status"
                defaultValue={installmentOption[0]}
                options={installmentOption}
                styles={customStyles()}
              />
            </Stack>
            {revision && (
              <Stack className="my-8">
                <label>Loan Balance</label>
                <TextField
                  className="mb-4 w-[180px]"
                  type="text"
                  required
                  variant="outlined"
                  fullWidth
                />
              </Stack>
            )}
          </Grid>
          <Grid xs={4}>
            <Stack className="my-8">
              <label>Transaction Date</label>
              <CustomDatePicker
                className="mb-4 w-[180px]"
                format={"dd-MM-yyyy"}
                name={"fromDate"}
              />
            </Stack>

            <Stack className="my-8">
              <label>Loan Type</label>

              <Select
                className="w-[180px]"
                name="pay_group"
                defaultValue={loanType[0]}
                options={loanType}
                styles={customStyles()}
              />
              <Stack className="my-8">
                <label className="my-2">Deduction Against</label>
                <Stack
                  sx={{ border: "1px solid whitesmoke", padding: 1 }}
                  direction="row"
                >
                  <Stack className="mr-8">
                    <label className="text-center">Amount</label>
                    <Stack direction={"row"}>
                      <label className="mr-4 w-[65px]">Payroll</label>
                      <TextField
                        className="mb-5 w-[120px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                      />
                    </Stack>
                    <Stack direction={"row"}>
                      <label className="mr-4 w-[65px]">Bonus</label>
                      <TextField
                        className="mb-5 w-[120px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                      />
                    </Stack>
                    <Stack direction={"row"}>
                      <label className="mr-4 w-[65px]">Gratuity</label>
                      <TextField
                        className="mb-5 w-[120px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                      />
                    </Stack>
                  </Stack>
                  <Stack className="mr-16">
                    <label>Percentage</label>

                    <TextField
                      className="mb-5 w-[120px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      className="mb-5 w-[120px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      className="mb-5 w-[120px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid xs={4} item>
            <Stack direction="row" spacing={2}>
              <Stack>
                <label>EMI DETAILS AGAINST PAYROLL</label>
                <Stack direction={"row"} sx={{ marginBottom: 1, marginTop: 1 }}>
                  <Stack sx={{ marginRight: 2 }}>
                    <label>Installment Amount</label>
                    <TextField
                      className="mb-4 w-[130px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                    />
                  </Stack>
                  <Stack sx={{ marginRight: 2 }}>
                    {revision ? (
                      <label>Remaining EMI</label>
                    ) : (
                      <label>Total EMI</label>
                    )}
                    <TextField
                      className="mb-4 w-[100px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                    />
                  </Stack>
                  {!revision && (
                    <Stack sx={{ marginRight: 2 }}>
                      <label>Start Date</label>
                      <CustomDatePicker
                        className="mb-4 w-[150px]"
                        format={"dd-MM-yyyy"}
                        name={"fromDate"}
                      />
                    </Stack>
                  )}
                </Stack>
                {!revision && (
                  <Stack>
                    <Button color="warning" variant="contained">
                      {" "}
                      Generate EMI
                    </Button>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </div>

      <div className="h-full">
        <AgGridTable
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          rowGroupPanelShow="never"
          onGridReady={onGridReady}
          gridRef={gridRef}
        />
      </div>

      {/* <div className="h-full">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab label="NOLTE FZE" value={"nolte"} />
          <Tab label="FREE LANCE" value={"free-lance"} />
          <Tab label="IT CONSULTANT" value={"it-consultant"} />
        </Tabs>

        <AgGridTable
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          onRowDoubleClicked={onRowDoubleClicked}
          getContextMenuItems={getContextMenuItems}
        />
      </div> */}
    </>
  );
}
